import * as React from 'react';

import { Region } from 'glance-datatypes';

export const utcTimeZone: TimeZone = {
  city: 'GreenWich',
  code: 'UTC',
  hours: 0,
  minutes: 0,
};
export const usTimezone: TimeZone = {
  city: 'New York',
  code: 'EST',
  hours: -5,
  minutes: 0,
};
export const chinaTimezone: TimeZone = {
  city: 'Beijing',
  code: 'CST',
  hours: 8,
  minutes: 0,
};
export const indiaTimezone: TimeZone = {
  city: 'Calcutta',
  code: 'IST',
  hours: 5,
  minutes: 30,
};
export const krTimezone: TimeZone = {
  city: 'Seoul',
  code: 'KST',
  hours: 9,
  minutes: 0,
};
export const idTimezone: TimeZone = {
  city: 'Jakarta',
  code: 'IWST',
  hours: 7,
  minutes: 0,
};

export const defaultTimezone: TimeZone = utcTimeZone;

export const regionTimeZones = {
  [Region.CN]: ['CST-B'],
  [Region.AU]: ['UTC'],
  [Region.BD]: ['UTC'],
  [Region.HK]: ['UTC'],
  [Region.KE]: ['UTC'],
  [Region.NZ]: ['UTC'],
  [Region.LA]: ['UTC'],
  [Region.LK]: ['UTC'],
  [Region.MA]: ['UTC'],
  [Region.NP]: ['UTC'],
  [Region.PK]: ['UTC'],
  [Region.RU]: ['UTC'],
  [Region.TW]: ['UTC'],
  [Region.VN]: ['UTC'],
  [Region.KH]: ['UTC'],
  [Region.PH]: ['UTC'],
  [Region.SG]: ['UTC'],
  [Region.MM]: ['UTC'],
  [Region.TH]: ['UTC'],
  [Region.MY]: ['UTC'],
  [Region.IN]: ['IST'],
  [Region.US]: [
    'PST',
    // 'MST',
    'CST',
    'EST',
  ],
  [Region.KR]: ['KST'],
  [Region.ID]: ['IWST', 'ICST', 'IEST'],
  [Region.GLOBAL]: ['UTC'],
  [Region.ISLAMIC]: ['UTC'],
  [Region.NON_ISLAMIC]: ['UTC'],
  [Region.MX]: ['UTC'],
  [Region.BR]: ['UTC'],
  [Region.CO]: ['UTC'],
  [Region.JP]: ['UTC'],
  [Region.AT]: ['UTC'],
  [Region.DE]: ['UTC'],
  [Region.NG]: ['UTC'],
  [Region.GB]: ['UTC'],
  [-1]: ['UTC'],
};

export const timeZonesMap: Map<string, TimeZone> = new Map<string, TimeZone>();

//UTC as default
timeZonesMap.set('UTC', {
  city: 'GreenWich',
  code: 'UTC',
  hours: 0,
  minutes: 0,
});
//India Timezones
timeZonesMap.set('IST', {
  city: 'Calcutta',
  code: 'IST',
  hours: 5,
  minutes: 30,
});
//China Timezones
timeZonesMap.set('CST-B', {
  city: 'Beijing',
  code: 'CST',
  hours: 8,
  minutes: 0,
});
//US Timezones
timeZonesMap.set('EST', {
  city: 'New York',
  code: 'EST',
  hours: -5,
  minutes: 0,
});
timeZonesMap.set('CST', {
  city: 'Chicago',
  code: 'CST',
  hours: -6,
  minutes: 0,
});
// timeZonesMap.set('MST', {city: 'Salt Lake City',code: 'MST', hours: -7, minutes: 0})
timeZonesMap.set('PST', {
  city: 'Los Angeles',
  code: 'PST',
  hours: -8,
  minutes: 0,
});
//Korea Timezones
timeZonesMap.set('KST', { city: 'Seoul', code: 'KST', hours: 9, minutes: 0 });
//Indonesia Timezones
timeZonesMap.set('IWST', {
  city: 'Jakarta',
  code: 'IWST',
  hours: 7,
  minutes: 0,
});
timeZonesMap.set('ICST', {
  city: 'Makassar',
  code: 'ICST',
  hours: 8,
  minutes: 0,
});
timeZonesMap.set('IEST', {
  city: 'Manokwari',
  code: 'IEST',
  hours: 9,
  minutes: 0,
});

export interface TimeZone {
  code: string;
  city?: string;
  hours: number;
  minutes: number;
}

interface Props {
  timezone?: TimeZone;
  customStyle?: React.CSSProperties;
}

interface State {
  hours?: string;
  minutes?: string;
  timerId?: number;
}

export class ClockWithTimezone extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    this.setTime();
  }

  componentDidMount() {
    let timerID: number = setInterval(() => this.setTime(), 1000 * 60);
    this.setState({
      ...this.state,
      timerId: timerID,
    });
  }

  componentWillUnmount() {
    clearInterval(this.state.timerId);
  }

  getTimezone(): TimeZone {
    return this.props.timezone ? this.props.timezone : defaultTimezone;
  }

  setTime() {
    const timezone: TimeZone = this.getTimezone();
    let currentdate: Date = new Date();

    currentdate.setHours(currentdate.getUTCHours() + timezone.hours);
    currentdate.setMinutes(currentdate.getUTCMinutes() + timezone.minutes);

    let hoursNumber: number = currentdate.getHours();
    // correct for number over 24, and negatives
    // if ( hoursNumber >= 24 ){ hoursNumber -= 24; }
    // if ( hoursNumber < 0   ){ hoursNumber += 12; }

    // add leading zero, first convert hours to string
    let hours = hoursNumber + '';
    if (hours.length == 1) {
      hours = '0' + hours;
    }

    // minutes are the same on every time zone
    let minutesNumber: number = currentdate.getMinutes();

    // add leading zero, first convert hours to string
    let minutes = minutesNumber + '';
    if (minutes.length == 1) {
      minutes = '0' + minutes;
    }

    this.setState({
      ...this.state,
      hours: hours,
      minutes: minutes,
    });
  }

  render() {
    let timezone = this.getTimezone();

    return (
      <span style={this.props.customStyle}>
        {timezone.city}{' '}
        <span style={{ backgroundColor: 'rgba(0,0, 0, 0.3)', padding: '5px' }}>
          {this.state.hours}:{this.state.minutes} {timezone.code}
        </span>
      </span>
    );
  }
}

export default ClockWithTimezone;



// WEBPACK FOOTER //
// ./src/components/Clock.tsx